import { render, staticRenderFns } from "./shiftCard.vue?vue&type=template&id=067ae5c2&scoped=true&"
import script from "./shiftCard.vue?vue&type=script&lang=js&"
export * from "./shiftCard.vue?vue&type=script&lang=js&"
import style0 from "./shiftCard.vue?vue&type=style&index=0&id=067ae5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067ae5c2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VContainer,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle,VSheet,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('067ae5c2')) {
      api.createRecord('067ae5c2', component.options)
    } else {
      api.reload('067ae5c2', component.options)
    }
    module.hot.accept("./shiftCard.vue?vue&type=template&id=067ae5c2&scoped=true&", function () {
      api.rerender('067ae5c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Roster/RosterFormRecord/components/shiftCard.vue"
export default component.exports